import { useCallback, useEffect, useRef, useState } from "react";
import { emailApi, type Workspace } from "./api";

const POLL_MS = 30_000;
const MAX_POLLS = 40; // finite: about 20 minutes, restarts on focus

export function useEmailWorkspace() {
  const [data, setData] = useState<Workspace | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const seq = useRef(0);
  const polls = useRef(0);

  const refresh = useCallback(async () => {
    const mine = ++seq.current;
    try {
      const d = await emailApi<Workspace>("");
      if (mine !== seq.current) return;
      setData(d); setError(null);
    } catch (e) {
      if (mine !== seq.current) return;
      setError(e instanceof Error ? e.message : "Could not load the Email workspace.");
    } finally {
      if (mine === seq.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
    const t = setInterval(() => {
      if (document.hidden || polls.current >= MAX_POLLS) return;
      polls.current += 1; void refresh();
    }, POLL_MS);
    const onFocus = () => { polls.current = 0; void refresh(); };
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [refresh]);

  return { data, error, loading, refresh };
}
